var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"beacon-details-modal","title":_vm.$t('BEACON.DETAILS'),"title-class":"h4 font-weight-bold","lazy":"","size":"xl","hide-footer":""}},[_c('div',{staticClass:"d-flex px-3 py-5 mt-5 flex-column"},[_c('DeviceBeaconEditForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }